import React from 'react';

export default function ImageHTML({ url, title }) {
  const width = 768;
  const height = 432;
  const urlParts = url.split('.');
  const extension = urlParts.pop();
  const baseUrl = urlParts.join('.');
  const url768x432 = `${baseUrl}-${width}x${height}.${extension}`;
  const url300x169 = `${baseUrl}-300x169.${extension}`;
  const url1024x576 = `${baseUrl}-1024x576.${extension}`;
  const url1200 = `${baseUrl}.${extension}`;

  return (
    <img
      loading="lazy"
      decoding="async"
      width={width}
      height={height}
      src={url768x432}
      alt={title}
      srcSet={`${url768x432} ${width}w, ${url300x169} 300w, ${url1024x576} 1024w, ${url1200} 1200w`}
      sizes={`(max-width: ${width}px) 100vw, ${width}px`}
    />
  );
}